import * as R from 'ramda';
import * as P from 'plow-js';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// feature fleet-profile
import * as A from '../actions';
//////////////////////////////////////////////////

// monthly payroll deduction
const getVendorPayrollChargesIsPaidOnPayrollSuccess = (state, data) => (
  P.$set(
    'vendor.monthlyPayrollDeductionList',
    R.map(
      (entity) => R.assoc('deductionDisabled', R.prop(G.getGuidFromObject(entity), data), entity),
      R.path(['vendor', 'monthlyPayrollDeductionList'], state),
    ),
    state,
  )
);

// payroll accessorial
const getVendorPayrollAccessorialsIsPaidOnPayrollSuccess = (state, data) => (
  P.$set(
    'vendor.payrollAccessorialList',
    R.map(
      (entity) => R.assoc('deductionDisabled', R.prop(G.getGuidFromObject(entity), data), entity),
      R.path(['vendor', 'payrollAccessorialList'], state),
    ),
    state,
  )
);

// trucks by vendor
const getTrucksByVendorSuccess = (state, data) => (
  P.$set(
    'truckOptions',
    R.map(({ guid, unitId }) => ({
      [GC.FIELD_VALUE]: guid,
      [GC.FIELD_LABEL]: unitId,
    }), data),
    state,
  )
);

export const vendorReducer = {
  // trucks by vendor
  [A.getTrucksByVendorSuccess]: getTrucksByVendorSuccess,
  // monthly payroll deduction
  [A.getVendorPayrollChargesIsPaidOnPayrollSuccess]: getVendorPayrollChargesIsPaidOnPayrollSuccess,
  // payroll accessorial
  [A.getVendorPayrollAccessorialsIsPaidOnPayrollSuccess]: getVendorPayrollAccessorialsIsPaidOnPayrollSuccess,
};
